import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ActivityMetricTrackDetailsFragment = { id: string, metricId: string, name: string, targetValue: number, targetFrequency: Types.RelativeDateFilterUnitEnum, weight?: number | null, weightPriority?: Types.WeightPriorityEnum | null };


export type ActivityMetricTrackDetailsFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type OrgRoleActivityMetricTrackDetailsFragment = { __typename: 'OrgRoleType', id: string, activityMetrics?: Array<{ __typename: 'ActivityMetricType', id: string, metricId: string, name: string, targetValue: number, targetFrequency: Types.RelativeDateFilterUnitEnum, weight?: number | null, weightPriority?: Types.WeightPriorityEnum | null }> | null };


export type OrgRoleActivityMetricTrackDetailsFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type MetricTrackDetailsFragment = { __typename: 'MetricSchema', id: string, name: string, description?: string | null, measurementUnit: Types.KeyResultMetricEnum, measurementValueFormat?: Types.MeasurementValueFormatEnum | null, integration?: { id: string, name: string, iconUrl: string } | null, syncConfig: { type: Types.MetricSyncTypeEnum, integrationId?: string | null }, manualMetricConfig?: { columnConfigs: Array<{ name: string }> } | null };


export type MetricTrackDetailsFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type TrackDetailsActivitiesFragment = { __typename: 'TrackType', id: string, metricIds?: Array<string> | null, metrics?: Array<{ __typename: 'MetricSchema', id: string, name: string, description?: string | null, measurementUnit: Types.KeyResultMetricEnum, measurementValueFormat?: Types.MeasurementValueFormatEnum | null, integration?: { id: string, name: string, iconUrl: string } | null, syncConfig: { type: Types.MetricSyncTypeEnum, integrationId?: string | null }, manualMetricConfig?: { columnConfigs: Array<{ name: string }> } | null }> | null, orgRoles?: Array<{ __typename: 'OrgRoleType', id: string, activityMetrics?: Array<{ __typename: 'ActivityMetricType', id: string, metricId: string, name: string, targetValue: number, targetFrequency: Types.RelativeDateFilterUnitEnum, weight?: number | null, weightPriority?: Types.WeightPriorityEnum | null }> | null }> | null };


export type TrackDetailsActivitiesFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type MetricDetailsFromCacheQueryVariables = Types.Exact<{
  filters: Types.GetByIdFilter;
}>;


export type MetricDetailsFromCacheQuery = { metric?: { __typename: 'MetricSchema', id: string, name: string, description?: string | null, measurementUnit: Types.KeyResultMetricEnum, measurementValueFormat?: Types.MeasurementValueFormatEnum | null, integration?: { id: string, name: string, iconUrl: string } | null, syncConfig: { type: Types.MetricSyncTypeEnum, integrationId?: string | null }, manualMetricConfig?: { columnConfigs: Array<{ name: string }> } | null } | null };

export type TrackDetailsActivitiesQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.TrackFilters>;
}>;


export type TrackDetailsActivitiesQuery = { track?: { __typename: 'TrackType', id: string, metricIds?: Array<string> | null, metrics?: Array<{ __typename: 'MetricSchema', id: string, name: string, description?: string | null, measurementUnit: Types.KeyResultMetricEnum, measurementValueFormat?: Types.MeasurementValueFormatEnum | null, integration?: { id: string, name: string, iconUrl: string } | null, syncConfig: { type: Types.MetricSyncTypeEnum, integrationId?: string | null }, manualMetricConfig?: { columnConfigs: Array<{ name: string }> } | null }> | null, orgRoles?: Array<{ __typename: 'OrgRoleType', id: string, activityMetrics?: Array<{ __typename: 'ActivityMetricType', id: string, metricId: string, name: string, targetValue: number, targetFrequency: Types.RelativeDateFilterUnitEnum, weight?: number | null, weightPriority?: Types.WeightPriorityEnum | null }> | null }> | null } | null };

export const MetricTrackDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment MetricTrackDetails on MetricSchema {
  id
  name
  description
  measurementUnit
  measurementValueFormat
  integration {
    id
    name
    iconUrl
  }
  syncConfig {
    type
    integrationId
  }
  manualMetricConfig {
    columnConfigs {
      name
    }
  }
  __typename
}
    `;
export const ActivityMetricTrackDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment ActivityMetricTrackDetails on ActivityMetricType {
  id
  metricId
  name
  targetValue
  targetFrequency
  weight
  weightPriority
}
    `;
export const OrgRoleActivityMetricTrackDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment OrgRoleActivityMetricTrackDetails on OrgRoleType {
  id
  activityMetrics {
    ...ActivityMetricTrackDetails
    __typename
  }
  __typename
}
    `;
export const TrackDetailsActivitiesFragmentDoc = /*#__PURE__*/ gql`
    fragment TrackDetailsActivities on TrackType {
  id
  metricIds
  metrics {
    ...MetricTrackDetails
    __typename
  }
  orgRoles {
    ...OrgRoleActivityMetricTrackDetails
  }
  __typename
}
    `;
export const MetricDetailsFromCacheDocument = /*#__PURE__*/ gql`
    query metricDetailsFromCache($filters: GetByIdFilter!) {
  metric(filters: $filters) {
    ...MetricTrackDetails
    __typename
  }
}
    ${MetricTrackDetailsFragmentDoc}`;

export function useMetricDetailsFromCacheQuery(options: Omit<Urql.UseQueryArgs<MetricDetailsFromCacheQueryVariables>, 'query'>) {
  return Urql.useQuery<MetricDetailsFromCacheQuery, MetricDetailsFromCacheQueryVariables>({ query: MetricDetailsFromCacheDocument, ...options });
};
export const TrackDetailsActivitiesDocument = /*#__PURE__*/ gql`
    query trackDetailsActivities($filters: TrackFilters) {
  track(filters: $filters) {
    ...TrackDetailsActivities
  }
}
    ${TrackDetailsActivitiesFragmentDoc}
${MetricTrackDetailsFragmentDoc}
${OrgRoleActivityMetricTrackDetailsFragmentDoc}
${ActivityMetricTrackDetailsFragmentDoc}`;

export function useTrackDetailsActivitiesQuery(options?: Omit<Urql.UseQueryArgs<TrackDetailsActivitiesQueryVariables>, 'query'>) {
  return Urql.useQuery<TrackDetailsActivitiesQuery, TrackDetailsActivitiesQueryVariables>({ query: TrackDetailsActivitiesDocument, ...options });
};